// eslint-disable-next-line @typescript-eslint/no-var-requires
const manifest = require('./package.json');
const version = manifest.version;
const vueVersion = manifest.dependencies.vue.replace(/[^\d.]/g, '');
const wbDependency = manifest.dependencies['@workbench/core'];

const versionRegex = new RegExp(/(\d+\.\d+\.\d+)/g);
const [wbVersion] = versionRegex.exec(wbDependency) || [];

module.exports = {
  APP_VERSION: version,
  VUE_VERSION: vueVersion,
  WORKBENCH_VERSION: wbVersion,
};
